import React from 'react'
import useMaybeTrailer from '../hooks/useMaybeTrailer'
import BackgroundVideo from './BackgroundVideo'
import BackgroundVisuals from './BackgroundVisuals'
import { compose } from 'redux'
import { connect } from 'react-redux'
import toJS from '../hoc/toJS'
import { UI_TRAILER } from '../constants/state'
import getData from '../functions/getData'


const mapStateToProps = (state, ownProps) => ({
    hasYoutubeCookieConfirmation: getData(state, [UI_TRAILER, 'hasYoutubeCookieConfirmation'])
})

const BackgroundVisualsSwitch = ({
    isInViewport,
    isInHighlight,
    oddSlide,
    kenBurnsToggle,
    canParallax,
    isJustOneItem,
    backgroundVisualsSettings,
    autoplaySpeed,
    backgroundImage,
    poster,
    trailerURL,
    isMobile,
    isConnectedFast,
    hasYoutubeCookieConfirmation,
    fsk,
    isCurrentSlide
}) => {
    const [maybeVideo, youtubeId] = useMaybeTrailer(backgroundVisualsSettings.trailerAutoplay, trailerURL, fsk)

    if(false === maybeVideo) {
        return <BackgroundVisuals
            isInHighlight={isInHighlight}
            oddSlide={oddSlide}
            backgroundVisualsSettings={backgroundVisualsSettings}
            autoplaySpeed={autoplaySpeed}
            backgroundImage={backgroundImage}
            isMobile={isMobile}
            poster={poster}
            canParallax={canParallax}
            kenBurnsToggle={kenBurnsToggle}
            isJustOneItem={isJustOneItem}
        />
    } else if(true === maybeVideo) {
        return <BackgroundVideo
            isConnectedFast={isConnectedFast}
            hasYoutubeCookieConfirmation={hasYoutubeCookieConfirmation}
            youtubeId={youtubeId}
            isInViewport={isInViewport && isCurrentSlide}
            backgroundImage={backgroundImage}
            isMobile={isMobile}
        />
    } else {
        return ''
    }
}

export default compose(
    connect(mapStateToProps, null),
    toJS()
)(BackgroundVisualsSwitch)